// Die Filterzeile über einer Tabelle: eine Zeile, keine Seitenleiste (parts4/00-contract.md,
// „Composition"). `role="group"` mit `aria-label`, damit ein Bildschirmleser die Filter als eine
// Einheit ansagt und nicht als lose Felder zwischen Überschrift und Tabelle.
import type { ReactElement, ReactNode } from 'react'
import './bausteine.css'

export interface LeisteProps {
  beschriftung: string
  /**
   * Macht aus der Gruppe einen benannten Bereich (`<section>` mit `aria-label`, also `role="region"`).
   * Für Leisten, die mehr tragen als lose Felder — etwa den Satz, auf welches Datum ein Monatsfilter
   * bucht: so findet eine Vorlesesoftware sie im Verzeichnis der Bereiche wieder. Optik und Klasse
   * bleiben dieselben, damit die Filterzeile nicht in zwei Dateien beschrieben werden muss.
   */
  bereich?: boolean
  children: ReactNode
}

export function Leiste({ beschriftung, bereich = false, children }: LeisteProps): ReactElement {
  if (bereich) {
    return (
      <section className="leiste" aria-label={beschriftung}>
        {children}
      </section>
    )
  }
  return (
    <div className="leiste" role="group" aria-label={beschriftung}>
      {children}
    </div>
  )
}
